// Function to read files in the directory
export const getFileNameWithoutExt = (fileName) => {
    return fileName.replace(/\.[^.]+$/, '');
};
